import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gesellschaft',
    name: 'pages-gesellschaft',
    component: () => import(/* webpackChunkName: "gesellschaft" */ '../pages/Gesellschaft.vue')
  },
  {
    path: '/hoffnungen',
    name: 'pages-hoffnungen',
    component: () => import(/* webpackChunkName: "hoffnungen" */ '../pages/Hoffnungen.vue')
  },
  {
    path: '/kennen',
    name: 'pages-kennen',
    component: () => import(/* webpackChunkName: "kennen" */ '../pages/Kennen.vue')
  },
  {
    path: '/mauerfall',
    name: 'pages-mauerfall',
    component: () => import(/* webpackChunkName: "mauerfall" */ '../pages/Mauerfall.vue')
  },
  {
    path: '/medien',
    name: 'pages-medien',
    component: () => import(/* webpackChunkName: "medien" */ '../pages/Medien.vue')
  },
  {
    path: '/montagsdemos',
    name: 'pages-montagsdemos',
    component: () => import(/* webpackChunkName: "montagsdemos" */ '../pages/Montagsdemos.vue')
  },
  {
    path: '/politische-entwicklung',
    name: 'pages-politische-entwicklung',
    component: () => import(/* webpackChunkName: "politische-entwicklung" */ '../pages/PolitischeEntwicklung.vue')
  },
  {
    path: '/sicht',
    name: 'pages-sicht',
    component: () => import(/* webpackChunkName: "sicht" */ '../pages/Sicht.vue')
  },
  {
    path: '/stimmung',
    name: 'pages-stimmung',
    component: () => import(/* webpackChunkName: "stimmung" */ '../pages/Stimmung.vue')
  },
  {
    path: '/wirtschaft',
    name: 'pages-wirtschaft',
    component: () => import(/* webpackChunkName: "wirtschaft" */ '../pages/Wirtschaft.vue')
  },
  {
    path: '/about',
    name: 'pages-about',
    component: () => import(/* webpackChunkName: "about" */ '../pages/About.vue')
  },
  {
    path: '/impressum',
    name: 'pages-impressum',
    component: () => import(/* webpackChunkName: "impressum" */ '../pages/Impressum.vue')
  },
  {
    path: '/privacy',
    name: 'pages-privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../pages/Privacy.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
